import React from 'react';
import Section from '../../../../components/Display/Section';
import Data from '../../../../components/Display/Data';
import DataTag from '../../../../components/Display/DataTag';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import MultipleDataTag from '../../../../components/Display/MultipleDataTag';
import MultiLineData from '../../../../components/Display/MultiLineData';
import { getConstant } from '../../../../utils/constants';

function ExternalResourceDetail({ resource, handleUpdateResource, handleDelete }) {
  const updateResourceActions = [
    {
      onClick: handleUpdateResource,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (event) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cet Évènement ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      acceptClassName: 'bg-red-500 border-red-500',
      accept: () => handleDelete(event)
    });
  };

  return (
    <div className={`h-full w-full flex-col flex gap-5`}>
      <Section label="Informations Générales" actions={updateResourceActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={resource.title} large />
          <Data key="src_url" label={'Url de la source'} value={resource.src_url} large />

          <div className="flex flex-wrap gap-5">
            <MultipleDataTag
              key="publilc_list"
              label={'Public Cible'}
              tags={resource.public_list.map((ot) => ({
                label: ot.label,
                bgColor: 'bg-yellow-500',
                icon: 'man'
              }))}
            />
          </div>
          <DataTag
            key="theme"
            label={'Theme'}
            tag={{
              label: getConstant('solarys.themeList', resource.theme).label,
              icon: 'colors',
              bgColor: 'bg-orange-700'
            }}
            large
          />
        </div>
        <MultiLineData key="instruction" label={'Instruction'} value={resource.instruction} />
      </Section>
      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'évènement"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(resource)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default ExternalResourceDetail;
